import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M108.5,224a5.888,5.888,0,0,0-4.385,1.95.45.45,0,1,0,.67.6,5.006,5.006,0,0,1,7.43,0,.45.45,0,0,0,.671-.6A5.888,5.888,0,0,0,108.5,224Z",
    transform: "translate(-98.153 -211.4)"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10.35,0A10.35,10.35,0,1,0,20.7,10.35,10.362,10.362,0,0,0,10.35,0Zm0,19.8a9.45,9.45,0,1,1,9.45-9.45A9.461,9.461,0,0,1,10.35,19.8Z" }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M212.05,128a.45.45,0,0,0-.45.45,1.35,1.35,0,1,1-2.7,0,.45.45,0,0,0-.9,0,2.25,2.25,0,0,0,4.5,0A.45.45,0,0,0,212.05,128Z",
    transform: "translate(-196.3 -120.8)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M84.5,128.45a.45.45,0,0,0-.9,0,1.35,1.35,0,1,1-2.7,0,.45.45,0,0,0-.9,0,2.25,2.25,0,0,0,4.5,0Z",
    transform: "translate(-75.5 -120.8)"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_icon_base = _resolveComponent("as-icon-base")!

  return (_openBlock(), _createBlock(_component_as_icon_base, { viewBox: "0 0 20.7 20.7" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}